export default __webpack_public_path__ + "static/media/Generic-WEB.ea9ffa57.svg";